<template>
  <v-row dense class="row-image-grid-info">
    <v-col cols="12" class="col-image-grid-info">
      <v-row dense>
        <v-col cols="6">Data abate</v-col><v-col cols="6" class="text-right"><strong>{{animal.dt_abate | formatDate}}</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info">
      <v-row dense>
        <v-col cols="6">Sequencial</v-col><v-col cols="6" class="text-right"><strong>{{animal.nr_sequencial_ind}}</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">Peso vivo</v-col><v-col cols="6" class="text-right"><strong>{{formatNumber(animal.peso_vivo, 0)}} Kg</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">P1</v-col><v-col cols="6" class="text-right"><strong>{{animal.peso_final_carcaca_1}} Kg</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">P2</v-col><v-col cols="6" class="text-right"><strong>{{animal.peso_final_carcaca_2}} Kg</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">P1+P2</v-col><v-col cols="6" class="text-right"><strong>{{animal.total_carcaca}} Kg</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">RC</v-col><v-col cols="6" class="text-right"><strong>{{animal.rendimento}} %</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">Acabamento</v-col><v-col cols="6" class="text-right"><strong>{{ auxs['finish'][animal.acabamento_id] ? auxs['finish'][animal.acabamento_id] : animal.acabamento_id }}</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">Conformação</v-col><v-col cols="6" class="text-right"><strong>{{ auxs['conformation'][animal.conformacao_id] ? auxs['conformation'][animal.conformacao_id] : animal.conformacao_id }}</strong></v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="col-image-grid-info" v-if="!animal.weigth_purchase">
      <v-row dense>
        <v-col cols="6">Maturidade</v-col><v-col cols="6" class="text-right"><strong>{{ auxs['maturity'][animal.maturidade_id] ? auxs['maturity'][animal.maturidade_id] : animal.maturidade_id }}</strong></v-col>
      </v-row>
    </v-col>
  </v-row>  
</template>
<script>
  export default {
    name: 'app-image-grid-info',
    props : ['animal', 'auxs'],
    data: () => ({
      
    }),
    mounted () {
      
    },
    methods : {
      formatNumber(number, qtddecimal) {
        return parseFloat(number).toFixed(parseInt(qtddecimal));
      }
    }
  }
</script>

<style scoped lang="css">
  .row-image-grid-info .col-image-grid-info:nth-of-type(odd) {
    background-color: rgba(0,0,0,.05);
  }
</style>
